import { SWRConfiguration } from 'swr';

import { DocumentType } from '~/data/documents';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const saveEmployeeDocument = async (
  employeeId: number,
  submissionData: FormData,
  updateDocumentId?: number,
): Promise<DocumentType> => {
  if (!!updateDocumentId) {
    return await fetchFromOldApi(
      `/form/employee/${employeeId}/file/${updateDocumentId}`,
      {
        method: 'PUT',
        body: submissionData as FormData,
      },
    ).then((r) => r.json());
  } else {
    return await fetchFromOldApi(`/form/employee/${employeeId}/file`, {
      method: 'POST',
      body: submissionData as FormData,
    }).then((r) => r.json());
  }
};

export const deleteEmployeeDocument = async (
  employeeId: number,
  documentId: number,
) => {
  return await fetchFromOldApi(
    `/json/employee/${employeeId}/file/${documentId}`,
    {
      method: 'DELETE',
    },
  ).then((r) => r.json());
};

export const getEmployeeDocuments = (
  employeeId: number,
  includeReadOnly?: boolean,
): Promise<DocumentType[]> => {
  const queryParams = !!includeReadOnly ? '?includeReadOnly=true' : '';

  return fetchFromOldApi(
    `/json/employee/${employeeId}/file${queryParams}`,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId?: number;
  includeReadOnly?: boolean;
};

export const useGetEmployeeDocuments = (
  props: PropsType,
  swrConfig?: SWRConfiguration<DocumentType[]>,
  isDisabled?: boolean,
): UseArraySWROutput<DocumentType> => {
  const { employeeId, includeReadOnly } = props;

  return useArraySWR(
    !isDisabled && !!employeeId
      ? ['employeeDocuments', employeeId, includeReadOnly]
      : null,
    ([_key, employeeId, includeReadOnly]: [
      string,
      number,
      boolean | undefined,
    ]) =>
      getEmployeeDocuments(employeeId, includeReadOnly).then((data) => {
        return data.sort((a: DocumentType, b: DocumentType) => {
          return (
            new Date(b.fDocumentCreated).valueOf() -
            new Date(a.fDocumentCreated).valueOf()
          );
        });
      }),
    swrConfig,
  );
};
